import { createSlice } from "@reduxjs/toolkit";

export interface AdminState {
  schoolId: number;
  schoolName: string;
}

const initialState: AdminState = {
  schoolId: 0,
  schoolName: "",
};

export const adminSlice = createSlice({
  name: "admin",
  initialState: initialState,
  reducers: {
    setAdminState: (state, action) => {
      state.schoolId = action.payload.schoolId;
      state.schoolName = action.payload.schoolName;
    },
  },
});

export const { setAdminState } = adminSlice.actions;
export default adminSlice.reducer;
